import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { selectCurrentToken } from "../../store/feautures/AuthSlice";


export default function PublicGuard({children} : any) {
    const isAuth = useSelector(selectCurrentToken);
    return isAuth ? <Navigate to={"/dashboard/home"} /> : <>{children}</>;
 }
 